document.addEventListener('DOMContentLoaded', function() {
  const accordionContainers = document.querySelectorAll('[data-featured-accordion]');
  
  accordionContainers.forEach(container => {
    const toggles = container.querySelectorAll('[data-featured-accordion-toggle]');
    const multiple = container.hasAttribute('data-accordion-multiple') && 
                     container.getAttribute('data-accordion-multiple') === 'true';

    function isMobile() {
      return window.innerWidth < 990;
    }

    // Initialize: ensure first item is expanded
    if (toggles.length > 0) {
      const firstToggle = toggles[0];
      const firstContentId = firstToggle.getAttribute('aria-controls');
      const firstContent = document.getElementById(firstContentId);
      
      if (firstContent) {
        firstToggle.setAttribute('aria-expanded', 'true');
        firstContent.removeAttribute('hidden');
      }
    }

    toggles.forEach(toggle => {
      const contentId = toggle.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (content) {
        const handleToggle = function(event) {
          event.preventDefault();
          
          if (isMobile()) return;
          
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

          if (!isExpanded) {
            if (!multiple) {
              collapseAll(container);
            }

            // Expand clicked item
            toggle.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
          } else {
            // If multiple mode, allow collapsing
            if (multiple) {
              toggle.setAttribute('aria-expanded', 'false');
              content.setAttribute('hidden', 'true');
            }
            // If not multiple mode, keep at least one open (do nothing)
          }
        };

        toggle.addEventListener('click', handleToggle);
        
        // Add keyboard support
        toggle.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            handleToggle(event);
          }
        });
      }
    });
    
    // Add keyboard navigation for desktop toggles
    toggles.forEach((toggle, index) => {
      toggle.addEventListener('keydown', function(event) {
        switch(event.key) {
          case 'ArrowDown':
            event.preventDefault();
            toggles[(index + 1) % toggles.length].focus();
            break;
          case 'ArrowUp':
            event.preventDefault();
            toggles[(index - 1 + toggles.length) % toggles.length].focus();
            break;
          case 'Home':
            event.preventDefault();
            toggles[0].focus();
            break;
          case 'End':
            event.preventDefault();
            toggles[toggles.length - 1].focus();
            break;
        }
      });
    });

    // Mobile: Add click handlers to content cards
    const allContent = container.parentElement.querySelectorAll('[data-featured-accordion-content]');
    allContent.forEach((content, index) => {
      // Create mobile header with icon and title
      const mobileHeader = document.createElement('button');
      mobileHeader.className = 'c-featured-accordion__mobile-header';
      mobileHeader.setAttribute('aria-expanded', index === 0 ? 'true' : 'false');
      
      const iconUrl = content.getAttribute('data-mobile-icon');
      const title = content.getAttribute('data-mobile-title');
      
      let iconHTML = '';
      if (iconUrl) {
        iconHTML = `<span class="c-featured-accordion__icon"><img src="${iconUrl}" alt="" width="45" height="45" class="c-featured-accordion__icon-image"></span>`;
      }
      
      mobileHeader.innerHTML = `
        ${iconHTML}
        <span class="c-featured-accordion__title">${title}</span>
        <span class="c-featured-accordion__arrow">
          <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9287 0.292745C15.3191 -0.0976805 15.9522 -0.0974828 16.3428 0.292745L22.707 6.657C23.0974 7.04754 23.0975 7.68058 22.707 8.07106L16.3428 14.4353C15.9523 14.8254 15.3191 14.8256 14.9287 14.4353C14.5383 14.0449 14.5386 13.4118 14.9287 13.0213L19.5859 8.36403H1C0.44779 8.36403 0.0001211 7.91622 0 7.36403C0 6.81175 0.447715 6.36403 1 6.36403H19.5859L14.9287 1.70681C14.5385 1.3163 14.5384 0.683179 14.9287 0.292745Z" fill="white"/>
          </svg>
        </span>
      `;
      
      content.insertBefore(mobileHeader, content.firstChild);
      
      mobileHeader.addEventListener('click', function() {
        if (!isMobile()) return;
        
        const isExpanded = mobileHeader.getAttribute('aria-expanded') === 'true';
        
        if (!isExpanded) {
          // Collapse all others
          allContent.forEach(c => {
            const header = c.querySelector('.c-featured-accordion__mobile-header');
            if (header && c !== content) {
              header.setAttribute('aria-expanded', 'false');
              c.setAttribute('hidden', 'true');
            }
          });
          
          // Expand this one
          mobileHeader.setAttribute('aria-expanded', 'true');
          content.removeAttribute('hidden');
        } else {
          // Collapse this one
          mobileHeader.setAttribute('aria-expanded', 'false');
          content.setAttribute('hidden', 'true');
        }
      });
      
      // Set initial state for mobile
      if (index === 0) {
        content.removeAttribute('hidden');
        mobileHeader.setAttribute('aria-expanded', 'true');
      } else {
        content.setAttribute('hidden', 'true');
        mobileHeader.setAttribute('aria-expanded', 'false');
      }
    });
  });

  function collapseAll(container) {
    const allToggles = container.querySelectorAll('[data-featured-accordion-toggle]');
    
    allToggles.forEach(toggle => {
      const contentId = toggle.getAttribute('aria-controls');
      const content = document.getElementById(contentId);
      
      if (content) {
        toggle.setAttribute('aria-expanded', 'false');
        content.setAttribute('hidden', 'true');
      }
    });
  }
});
